// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e8adb1b","455":"dad1ad9f","977":"21d1ec5b"}[chunkId] + ".chunk.js";
};